import { createContext, useContext } from "react";
import type { CurrentAdmin } from "@/api/session";
import type { AdminIdentity } from "@/api/types";

export interface AdminContextValue {
  identity: AdminIdentity;
  roleKnown: boolean;
  current: CurrentAdmin;
  mode: "http" | "mock";
}

export const AdminContext = createContext<AdminContextValue | null>(null);

export function useAdminContext(): AdminContextValue {
  const ctx = useContext(AdminContext);
  if (!ctx) throw new Error("useAdminContext must be used inside the authenticated shell");
  return ctx;
}
